export default __webpack_public_path__ + "static/blob11-0d2a728947b49eb802e5f42dd1ffd412.svg";